
export const Product = () => {
    return (
        <div>Product</div>
    )
}
